const SELECTOR = {
  LOGO: document.querySelector('[data-fixed-logo]'),
  TARGET: document.querySelector('[data-fixed-observer]'),
}

export default class FixedLogo {
  constructor() {
    if (!SELECTOR.LOGO || !SELECTOR.TARGET) return;

    const observer = new IntersectionObserver(this.callback);

    observer.observe(SELECTOR.TARGET);
  }

  callback(entries) {
    SELECTOR.LOGO.setAttribute(
      "data-fixed",
      String(!entries[0].isIntersecting)
    );
  };
}
